import { useQuery } from 'react-query';

import useApiHelper from '../../hooks/useApiHelper';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';
import { ChatHistoryMessages } from '../../types/Orbit/Chat';
import { orbitQueryKeys } from '../QueryKeys';

export default function useOrbitChatMessages(chatId?: string) {
  const { get } = useApiHelper();

  const messages = useQuery({
    queryKey: orbitQueryKeys.messages(chatId ?? ''),
    queryFn: () =>
      get<IDefaultResponseWithData<ChatHistoryMessages>>(
        `/v1/chat/${chatId}`
      ).then((res) => res.data.data),
    enabled: !!chatId,
  });

  return {
    messages,
  };
}
